import React from "react";

const SkeletonLoader = ({ type = "default", className = "" }) => {
  switch (type) {
    case "image":
      return (
        <div className={`animate-pulse space-y-4 ${className}`}>
          <div className="flex-1 space-y-4 py-1">
            <div className="h-56 bg-gray-200 rounded-md w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div>
          </div>
        </div>
      );

    case "text":
      return (
        <div className={`animate-pulse space-y-2 ${className}`}>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-4/6"></div>
        </div>
      );

    case "button":
      return (
        <div className={`animate-pulse ${className}`}>
          <div className="h-10 bg-gray-200 rounded-md w-full"></div>
        </div>
      );

    default:
      return (
        <div className={`animate-pulse space-y-4 ${className}`}>
          <div className="h-8 bg-gray-200 rounded w-2/3"></div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded"></div>
            <div className="h-4 bg-gray-200 rounded"></div>
            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          </div>
        </div>
      );
  }
};

export default SkeletonLoader;
